import { Routes, Route, Navigate } from "react-router-dom";
import DoctorLayout from "../layouts/DoctorLayout";
import PatientHistory from "../pages/doctor/PatientHistory";
import DoctorLogin from "../pages/doctor/DoctorLogin";
import DoctorForgotPassword from "../pages/doctor/DoctorForgotPassword";
import DoctorResetPassword from "../pages/doctor/DoctorResetPassword";
import DoctorDashboard from "../pages/DoctorDashboard";
import PatientCreate from "../pages/doctor/PatientCreate";
import PrescriptionPad from "../pages/doctor/PrescriptionPad";
import PrescriptionSettings from "../pages/doctor/PrescriptionSettings";
import PrescriptionPrintRouter from "../pages/doctor/PrescriptionPrintRouter";
import PatientSearch from "../pages/doctor/PatientSearch";
import PatientEdit from "../pages/doctor/PatientEdit";

/* ================= DAILY OPD GATE ================= */
/* Layout will never mount if login expired */
const MAX_SESSION_MS = 12 * 60 * 60 * 1000; // 12 hours

function DailyDoctorGate({children}){
  const token = sessionStorage.getItem("doctorToken");
  const loginTimestamp = parseInt(sessionStorage.getItem("doctorLoginTimestamp") || "0", 10);
  const sessionAge = Date.now() - loginTimestamp;

  if(
    !token ||
    token==="undefined" ||
    token==="null" ||
    token.trim()==="" ||
    !loginTimestamp ||
    sessionAge > MAX_SESSION_MS
  ){
    sessionStorage.removeItem("doctorToken");
    sessionStorage.removeItem("doctorLoginTimestamp");
    return <Navigate to="/staff-portal/login" replace />;
  }

  return children;
}

/* ================= ROUTES ================= */
export default function DoctorRoutes(){
  return(
    <Routes>

      {/* ⭐ ENTRY POINT */}
      <Route
  path="/"
  element={
    <DailyDoctorGate>
      <Navigate to="/staff-portal/dashboard" replace />
    </DailyDoctorGate>
  }
/>

      {/* ⭐ LOGIN */}
      <Route path="login" element={<DoctorLogin />} />
      <Route path="forgot-password" element={<DoctorForgotPassword />} />
      <Route path="reset-password" element={<DoctorResetPassword />} />

      {/* ⭐ PROTECTED */}
      <Route
  element={
    <DailyDoctorGate>
      <DoctorLayout/>
    </DailyDoctorGate>
  }
>

        {/* DASHBOARD */}
        <Route path="dashboard" element={<DoctorDashboard />} />

        <Route path="patient/new" element={<PatientCreate />} />

        <Route path="patient/search" element={<PatientSearch />} />

        <Route path="patient/edit/:patientId" element={<PatientEdit />} />

        <Route path="patient/history/:patientId" element={<PatientHistory />} />

        <Route path="prescription/:patientId" element={<PrescriptionPad />} />

        <Route path="prescription/:patientId/:rxId" element={<PrescriptionPad />} />

        <Route path="prescription/print/:rxId" element={<PrescriptionPrintRouter />} />

        <Route path="prescription-settings" element={<PrescriptionSettings />} />

      </Route>

      {/* ⭐ FALLBACK */}
      <Route path="*" element={<Navigate to="/staff-portal/login" replace />} />

    </Routes>
  )
}